var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"atom-progress-line",class:{'atom-progress-line--rounded': _vm.hasBorderRadius}},[_c('div',{staticClass:"atom-progress-line__body",class:{rounded: _vm.hasBorderRadius},style:({width: _vm.value + '%', transition: 'width ' + _vm.speed + 'ms'})})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2975f8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/packages/Progress/Line.vue
// module id = 354
// module chunks = 0